// extracted by mini-css-extract-plugin
export var descriptionList = "description_list-module--descriptionList--DMn1J";